import { render, staticRenderFns } from "./TeacherResources.vue?vue&type=template&id=9c7739ce&scoped=true&"
import script from "./TeacherResources.vue?vue&type=script&lang=js&"
export * from "./TeacherResources.vue?vue&type=script&lang=js&"
import style0 from "./TeacherResources.vue?vue&type=style&index=0&id=9c7739ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7739ce",
  null
  
)

export default component.exports